<template>
    <div class="sysFunc">
        <div class="home-right-content box-sizing">
            <div class="commer-list box-sizing">
                <p class="commer-list-title">
                    系统设置>功能管理
                </p>
                <!-- <div class="commer-list-seacch-box">
                    <div class="left-search">
                        
                    </div>
                    <div class="right-add">
                        <el-button type="info" icon="el-icon-plus"  @click='operation(1,"")'>新增</el-button>
                    </div>
                </div> -->
                <div class="commer-list-export-box">
                    <span>共查询到{{totals}}个结果</span>
                    <div class="right-add">
                        <el-button type="info" icon="el-icon-plus"  @click='operation(1,"")'>新增</el-button>
                    </div>
                    <!-- <span>导出Excel</span> -->
                </div>
                <div class="table-list">
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                            <el-table-column
                            type="index"
                            label="序号"
                            width="70">
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="名称"
                            width="180">
                            </el-table-column>
                            <el-table-column
                            prop="func"
                            label="功能">
                            </el-table-column>
                            <el-table-column
                            prop="status"
                            label="状态">
                                <template slot-scope="scope">
                                    <span v-for='item in statusList' v-if="item.value==scope.row.status">{{item.lable}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="createDate"
                            label="创建时间">
                                <template slot-scope="scope">
                                    <span>{{scope.row.createDate | dateFormat }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                            label="操作"
                            width="160">
                            <template slot-scope="scope">
                                <el-button type="text" size="small"  @click='ifDelete(scope.row.id)'>删除</el-button>
                                <el-button type="text" size="small" @click='operation(2,scope.row.id)'>编辑</el-button>
                            </template>
                            </el-table-column>
                    </el-table>
                </div>
                <div class="pages">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="getListParams.pageNo"
                        :page-size="getListParams.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totals">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
        :title="titleMsg"
        :visible.sync="ifAdd"
        :modal-append-to-body='false'
        width='28%'>
        <el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
            <el-form-item label="名称" prop="name">
                <el-input v-model="addParams.name"></el-input>
            </el-form-item>
            <el-form-item label="功能" prop="func">
                <el-input type="textarea" v-model="addParams.func"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="addParams.status" placeholder="请选择状态">
                    <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="ifAdd = false">取 消</el-button>
            <el-button type="primary" @click="save('addParams')">保 存</el-button>
        </span>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="ifDeleteBox"
            :modal-append-to-body='false'
            width="30%">
            <span class="ifDetetes">是否删除</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ifDeleteBox = false">取 消</el-button>
                <el-button type="primary" @click="sureDelete">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                tableData:[],
                totals:1,
                ifAdd:false,
                ifDeleteBox:false,
                titleMsg:'新增',
                params:{
                    name:''
                },
                rules:{
                    name:[{required: true,message: '请输入名称'}],
                    func:[{required: true,message: '请输入功能'}],
                    status:[{required: true,message: '请选择状态'}],
                },
                getListParams:{
                    pageNo:1,
                    pageSize:10
                },
                statusList:[{
                    lable:'正常',
                    value:1
                },{
                    lable:'禁用',
                    value:0
                }],
                addParams:{
                    name:'',
                    func:'',
                    status:''
                },
                companyID:''
            }
        },
        methods:{
            //出现新增/编辑框
            operation:function(val,id){
                var vm=this;
                vm.ifAdd=true
                if(val==1){
                    vm.titleMsg='新增'
                    vm.addParams={
                        name:'',
                        func:'',
                        status:''
                    }
                }else{
                    vm.titleMsg='编辑'
                    vm.$http.get('/api/console/sysFunc/query',{
                        params:{
                            id:id
                        }
                    }).then(function(response){
                        let resTemp=response.data
                        for(var i in resTemp){
                            if(i=='createDate'||i=='updateDate'){
                                delete resTemp[i]
                            }
                        }
                        vm.addParams=resTemp
                    })

                }
            },
            //获取列表
            getDatas:function(){
                var vm=this;
                vm.$http.get('/api/console/sysFunc/queryPage',{
                    params:vm.getListParams
                }).then(function(response){
                  
                    vm.tableData=response.data.items
                    vm.totals=parseInt(response.data.page.rowCount)*1
                })
            },
            //分页
            handleCurrentChange:function(val){
                this.getListParams.pageNo=val;
                this.getDatas()
            },
            //保存
            save:function(formName){
                var vm=this;
                vm.$refs[formName].validate((valid) => {
                    if (valid) {
                        vm.$http.post('/api/console/sysFunc/save',vm.addParams)
                        .then(function(response){
                            if(response.code==0){
                                vm.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                vm.ifAdd=false;
                                vm.getDatas()
                            }
                        })
                    }
                })
            },
            //是否删除数据
			ifDelete:function(companyID){
				this.companyID=companyID
				this.ifDeleteBox=true
			},
            //确认删除
            sureDelete:function(){
                var vm=this;
				vm.$http.post('/api/console/sysFunc/delete',{ids:vm.companyID})
				.then(function(response){
					if(response.code==0){
                        
                        vm.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        vm.ifDeleteBox=false
						vm.getDatas()
					}
						
				})
            }
        },
        mounted(){
            var vm=this;
            vm.getDatas()
        }
    }
</script>
<style lang="less">
    .sysFunc{
        .el-dialog__footer{
            text-align: center;
            .el-button{
                padding: 9px 20px;
            }
        }
        .ifDetetes{
            font-size: 16px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/views/systemSetup/sysFunc.vue